<script>
  import { encodeAlphanet, encodeMainnet } from "tezos-uri";

  import Box from "./Box.svelte";
  import ExampleBox from "./ExampleBox.svelte";

  let toEncode = "";
  $: alphanet = encodeWrapperAlpha(toEncode);
  $: mainnet = encodeWrapperMain(toEncode);

  function delegationWrapper(address) {
    return `[{"content":{"kind":"delegation","delegate":"` + address + `"}}]`;
  }

  function encodeWrapperAlpha(payload) {
    try {
      return encodeAlphanet(JSON.parse(delegationWrapper(payload)));
    } catch (e) {
      return e.toString();
    }
  }
  function encodeWrapperMain(payload) {
    try {
      return encodeMainnet(JSON.parse(delegationWrapper(payload)));
    } catch (e) {
      return e.toString();
    }
  }
</script>

<style>
  div#main {
    margin: 8px;
    width: 100%;
    background-color: #31466a;
    color: white;
  }

  h1 {
    font-weight: 300;
    font-size: 2.5rem;
  }

  #header > h1 > div {
    font-size: 1.6rem;
    margin-top: 0px;
    margin-left: 250px;
    width: fit-content;
  }
  a {
    text-decoration-line: underline;
    color: white;
  }
  div#content-grid > p {
    grid-area: p;
  }
  p {
    font-size: 1.2rem;
    margin: 12px;
  }

  div#boxes {
    grid-area: b;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    margin: 4px 10px;
  }

  div#header {
    grid-area: x;
    margin: auto;
  }

  @media (min-width: 992px) {
    div#content-grid {
      display: grid;
      grid-template:
        ". x ."
        ". p ."
        ". b .";
      grid-template-rows: auto auto auto;
      grid-template-columns: 1fr auto 1fr;
      grid-gap: 4px;
    }

    div#boxes {
      max-width: 992px;
    }
    div#content-grid > p {
      max-width: 992px;
    }
  }

  @media (max-width: 992px) {
    div#content-grid {
      display: grid;
      grid-template:
        "x"
        "p"
        "b";
      grid-template-rows: auto auto auto;
      grid-template-columns: auto;
      grid-gap: 4px;
    }

    h1 {
      font-size: 40px;
    }

    #header {
      margin: auto;
      text-align: center;
      width: fit-content;
      width: -moz-fit-content;
    }

    #header > h1 > div {
      font-size: 20px;
      margin-top: 0px;
      margin-left: auto;
      margin-right: 0px;
    }

    p {
      font-size: 18px;
    }
  }
</style>

<div id="main">
  <div id="content-grid">
    <div id="header">
      <h1>
        SCL Tezos URI Delegate Tool
        <div>
          by
          <a href="https://smartcontractlabs.ee">Smart Contract Labs</a>
        </div>
      </h1>
    </div>
    <p>
      Generate Tezos URI delegation requests here. Simply paste the Tezos
      address of your delegation service into the box below. The requests enable
      one-click delegation UX for your users. More information
      <a href="https://gitlab.com/smartcontractlabs/tezos-uri">here</a>.
    </p>

    <div id="boxes">
      <Box label={'Delegation Address'} bind:content={toEncode} />
      <ExampleBox label={'Alphanet Request'} bind:content={alphanet} />
      <p>
        Go to the
        <!-- <a href="https://tw.smartcontractlabs.ee">SCL Alphanet Wallet</a> -->
        <a>SCL Alphanet Wallet (coming soon)</a>
        and click the icon to use the wallet as a handler for
        <i>web+tezosalphanet</i>
        requests. Then copy the request above to the address bar of your browser
        and press
        <i>Enter</i>.
      </p>
      <ExampleBox label={'Mainnet Request'} bind:content={mainnet} />
      <p>
        If everything works OK, you can put the mainnet request on your website
        either as a button or a link.
      </p>
    </div>

  </div>

</div>
